// extracted by mini-css-extract-plugin
export default {"container":"D0-z","list":"E0-z"};